import { React, useEffect } from "react";
import { Container } from "react-bootstrap";
import AOS from "aos";
import profilePic from "../../Assets/Picture.png";
import { CaretDownFill } from "react-bootstrap-icons";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Testimonials = [
  {
    title: "Very Efficient",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed imperdiet nibh lectus feugiat nunc sem.",
    img: profilePic,
    name: "Jane Cooper",
    role: "CEO at ABC Corporation",
    id: 1,
  },
  {
    title: "Very Efficient",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed imperdiet nibh lectus feugiat nunc sem.",
    img: profilePic,
    name: "Jane Cooper",
    role: "CEO at ABC Corporation",
    id: 2,
  },
  {
    title: "Very Efficient",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed imperdiet nibh lectus feugiat nunc sem.",
    img: profilePic,
    name: "Jane Cooper",
    role: "CEO at ABC Corporation",
    id: 3,
  },
  {
    title: "Very Efficient",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed imperdiet nibh lectus feugiat nunc sem.",
    img: profilePic,
    name: "Jane Cooper",
    role: "CEO at ABC Corporation",
    id: 4,
  },
  {
    title: "Very Efficient",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed imperdiet nibh lectus feugiat nunc sem.",
    img: profilePic,
    name: "Jane Cooper",
    role: "CEO at ABC Corporation",
    id: 5,
  },
  {
    title: "Very Efficient",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed imperdiet nibh lectus feugiat nunc sem.",
    img: profilePic,
    name: "Jane Cooper",
    role: "CEO at ABC Corporation",
    id: 6,
  },
  {
    title: "Very Efficient",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor neque sed imperdiet nibh lectus feugiat nunc sem.",
    img: profilePic,
    name: "Jane Cooper",
    role: "CEO at ABC Corporation",
    id: 7,
  },
];

const fontSize = {
  fontSize: "0.86rem",
};

const TestimonialIcon = {
  marginTop: "-1.6rem",
  fontSize: "2.9rem",
};

const Clients = () => {
  useEffect(() => {
    AOS.init({ duration: 1700 });
  });

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 2,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Container className="h-100 py-3" style={{ background: "#DCFFEE" }} fluid>
      <div className=" my-5 text-center" data-aos="fade-up">
        <div className="our clients header my-3">
          <h3 className="display-7 fw-bold">Our Clients Speak</h3>
          <p className="lead" style={fontSize}>
            We have been working with clients across Nigeria
          </p>
        </div>
        <div className="cardsWidth row mx-auto mt-4 px-3 px-md-0 position-relative">
          <Slider {...settings}>
            {Testimonials.map((Testimonial) => {
              return (
                <div
                  key={Testimonial.id}
                  className="col-12 col-md-6 col-lg-4 mt-2 mt-md-0 w-100"
                >
                  <div className="card container bg-white rounded px-4 py-4 text-center border-0">
                    <h4 className="fw-bold fs-5">{Testimonial.title}</h4>
                    <p style={fontSize}>{Testimonial.desc}</p>
                  </div>
                  <div className="my-1 text-center">
                    <CaretDownFill
                      style={TestimonialIcon}
                      className="text-white"
                    />

                    <div className="mt-2">
                      <img
                        src={Testimonial.img}
                        alt=""
                        className="text-center mx-auto"
                      />
                    </div>
                    <div className="my-2">
                      <h6 style={fontSize} className="fw-bold">
                        {Testimonial.name}
                      </h6>
                      <p className="small">{Testimonial.role}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </Container>
  );
};

export default Clients;
